import React from "react";
import T from "prop-types";
import { FormattedMessage } from "react-intl";

import { childrenType } from "2g-types";

export function ZadostiRowDetailItem({ label, children }) {
  return (
    <div className="b2b-ZadostiRowDetail-item">
      <div className="b2b-ZadostiRowDetail-label b2b-ZadostiRowDetail-itemLabel">
        <FormattedMessage id={label} defaultMessage={label} />
      </div>
      <div className="b2b-ZadostiRowDetail-itemValue">{children}</div>
    </div>
  );
}

ZadostiRowDetailItem.propTypes = {
  label: T.string,
  children: childrenType
};

export default React.memo(ZadostiRowDetailItem);
